import React from 'react';
import { ShieldAlert, AlertTriangle } from 'lucide-react';

export default function RevokedMessageNotice({
  reason = 'anti_poaching_violation',
  violations = [],
  isSender = false
}) {
  return (
    <div
      data-testid="revoked-message-notice"
      className="max-w-xs sm:max-w-sm rounded-lg border border-red-200 bg-red-50/95 p-3 text-red-900 shadow-sm"
    >
      <div className="flex items-start space-x-2.5">
        <ShieldAlert className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-red-700 uppercase tracking-wider">
            Voice Note Removed
          </p>
          <p className="text-xs text-red-800 mt-0.5">
            This voice message was revoked following automated content policy review.
          </p>
          {violations && violations.length > 0 && (
            <div className="mt-1.5 pt-1.5 border-t border-red-200 text-[11px] text-red-600 flex items-center space-x-1">
              <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />
              <span>Policy violation detected: {violations[0]?.type || 'restricted contact info'}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
